<template>
  <b-modal title="Informações Sobre o Item" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Código:" label-for="codigo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="codigo" v-model="editing.codigo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Nome:" label-for="nome" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="nome" v-model="editing.nome" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Quantidade:" label-for="qtd" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="qtd" v-model="editing.quantidade" type="number" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Atendido:" label-for="atd" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="atd" v-model="editing.atendido" type="number" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { usePrioridadeStore } from "@/stores/PrioridadeStore";
import PrioridadeItem from "@/models/PrioridadeItem";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ModalDeEdicaoDePrioridadeItem",

  data() {
    return {
      show: false,
      editing: new PrioridadeItem(0, "", "Novo Item", 0, 0, new Date()),
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.prioridadeStore.ALTERAR_ITEM(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Item de prioridade salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      } else {
        this.prioridadeStore.CADASTRAR_ITEM(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Item de prioridade salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      }
      this.show = !this.show;
    },

    call(item) {
      this.show = !this.show;
      this.editing = item;
    },
  },

  setup() {
    const store = useSgcqStore();
    const prioridadeStore = usePrioridadeStore();

    return {
      store,
      prioridadeStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
